import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const LoginCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const user = JSON.parse(searchParams.get('user'));

    if (token && user) {
      loginWithToken(user, token);
      navigate('/dashboard');
    } else {
      navigate('/login?error=Authentication failed');
    }
  }, [navigate, searchParams, loginWithToken]);

  return null;
}; 